import React from 'react';

import { IconHandStop } from '@tabler/icons-react';
import { FullScreenAlert } from 'components/FullScreenAlert';
import { useTranslation } from 'react-i18next';

export function SmartAssistantForbiddenAlert() {
  const { t } = useTranslation();

  return (
    <FullScreenAlert
      header={<IconHandStop style={{ width: 60, height: 60, marginTop: 15 }} />}
      body={t('SMART_ASSISTANT.FORBIDDEN.DESCRIPTION')}
      notice={t('SMART_ASSISTANT.FORBIDDEN.NOTICE')}
    />
  );
}
